<template>
  <div class="Technology">
    <div class="techonlogy-section vehicle1">
      <h5 class="titel"><span>03</span> SPACE LAUNCH 101</h5>
      <div class="content">
        <div class="sid-cont">
          <div class="sid-nav">
            <ul>
              <li data-cont=".vehicle1" class="no-button active">1</li>
              <li data-cont=".vehicle2" class="no-button">2</li>
              <li data-cont=".vehicle3" class="no-button">3</li>
            </ul>
          </div>
          <div class="technology-cont">
            <div class="technology-dic">
              <label class="titel-dic">THE TERMINOLOGY…</label>
              <h3>LAUNCH VEHICLE</h3>
              <p>
                A launch vehicle or carrier rocket is a rocket-propelled vehicle
                used to carry a payload from Earth's surface to space, usually
                to Earth orbit or beyond. Our WEB-X carrier rocket is the most
                powerful in operation. Standing 150 metres tall, it's quite an
                awe-inspiring sight on the launch pad!
              </p>
            </div>
          </div>
        </div>
        <div class="vehicles-imgs">
          <img
            class="vehicle vehicle-1-img"
            src="../assets/Desktop/Vehicle-1.png"
            alt="Vehicle-1"
          />
        </div>
      </div>
    </div>
    <div class="techonlogy-section vehicle2">
      <h5 class="titel"><span>03</span> SPACE LAUNCH 101</h5>
      <div class="content">
        <div class="sid-cont">
          <div class="sid-nav">
            <ul>
              <li data-cont=".vehicle1" class="no-button">1</li>
              <li data-cont=".vehicle2" class="no-button active">2</li>
              <li data-cont=".vehicle3" class="no-button">3</li>
            </ul>
          </div>
          <div class="technology-cont">
            <div class="technology-dic">
              <label class="titel-dic">THE TERMINOLOGY…</label>
              <h3>SPACEPORT</h3>
              <p>
                A spaceport or cosmodrome is a site for launching (or receiving)
                spacecraft, by analogy to the seaport for ships or airport for
                aircraft. Based in the famous Cape Canaveral, our spaceport is
                ideally situated to take advantage of the Earth’s rotation for
                launch.
              </p>
            </div>
          </div>
        </div>
        <div class="vehicles-imgs">
          <img
            class="vehicle vehicle-2-img"
            src="../assets/Desktop/Vehicle-2.png"
            alt="Vehicle-2"
          />
        </div>
      </div>
    </div>
    <div class="techonlogy-section vehicle3">
      <h5 class="titel"><span>03</span> SPACE LAUNCH 101</h5>
      <div class="content">
        <div class="sid-cont">
          <div class="sid-nav">
            <ul>
              <li data-cont=".vehicle1" class="no-button">1</li>
              <li data-cont=".vehicle2" class="no-button">2</li>
              <li data-cont=".vehicle3" class="no-button active">3</li>
            </ul>
          </div>
          <div class="technology-cont">
            <div class="technology-dic">
              <label class="titel-dic">THE TERMINOLOGY…</label>
              <h3>SPACE CAPSULE</h3>
              <p>
                A space capsule is an often-crewed spacecraft that uses a
                blunt-body reentry capsule to reenter the Earth's atmosphere
                without wings. Our capsule is where you'll spend your time
                during the flight. It includes a space gym, cinema, and plenty
                of other activities to keep you entertained.
              </p>
            </div>
          </div>
        </div>
        <div class="vehicles-imgs">
          <img
            class="vehicle vehicle-3-img"
            src="../assets/Desktop/Vehicle-3.png"
            alt="Vehicle-3"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Technology",
  beforeCreate: function () {
    document.body.className = "technology";
  },
  mounted() {
    let sidNav = document.querySelectorAll(".sid-nav ul li");
    let sidArray = Array.from(sidNav);
    console.log(sidArray);
    let techSections = document.querySelectorAll(".Technology > div");
    let techArray = Array.from(techSections);
    console.log(techArray);

    sidArray.forEach((ele) => {
      ele.addEventListener("click", function (e) {
        techArray.forEach((tech) => {
          tech.style.display = "none";
        });
        document.querySelector(e.currentTarget.dataset.cont).style.display =
          "flex";
      });
    });
  },
};
</script>

<style lang="scss">
body.technology {
  background: url("../assets/Desktop/Technology-Background.jpg");
  background-size: 100vw 100vh;
  background-repeat: no-repeat;
}
.technology {
  .Technology > div:not(:first-child) {
    display: none;
  }
  .active {
    background: #ffffff;
    color: #0c0e19;
  }

  .titel {
    color: #ffffff;
    margin-top: 3em;
    margin-bottom: 0;
  }
  .titel span {
    padding-right: 8px;
    opacity: 0.25;
  }
  .techonlogy-section {
    position: relative;
    top: 6em;
    left: 10em;
    width: calc(100% - 10em);
  }
  .content {
    display: flex;
    flex-direction: row;
    width: 100%;
    // height: 530px;
    height: 55vh;
    justify-content: space-between;
    position: absolute;
    top: 8em;
  }
  .sid-cont {
    display: flex;
    flex-direction: row;
  }
  .sid-nav {
    height: 100%;
    display: flex;
    align-items: center;
    margin-right: 5em;
    ul {
      display: flex;
      flex-direction: column;
      padding: 0;
    }
    li {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      border: #ffffff solid 1px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: Bellefair;
      font-size: 32px;
      margin-bottom: 1em;
      cursor: pointer;
    }
    li:hover {
      background: #d0d6f9;
      color: #0c0e19;
      border: #d0d6f9;
    }
  }
  .technology-cont {
    display: flex;
    align-items: center;
    width: 75%;
    label.titel-dic {
      font-family: Barlow Condensed;
      font-size: 16px;
      letter-spacing: 2.7px;
      color: #d0d6f9;
      margin-bottom: 1em;
      display: block;
    }
  }
  .vehicles-imgs {
    width: 40%;
    .vehicle {
      height: 100%;
      width: 100%;
    }
  }
}
@media (max-width: 1000px) {
  body.technology {
    background-image: url("../assets/Tablet/Technology-Background.png");
  }
  .technology {
    .techonlogy-section {
      left: unset;
      width: unset;
    }
    .titel {
      margin-top: unset;
      position: absolute;
      top: -3rem;
      left: 2rem;
      z-index: 1;
    }
    .content {
      flex-direction: column-reverse;
      align-items: center;
      top: 8rem;
    }
    .sid-cont {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      width: 100%;
    }
    .sid-nav {
      margin-right: unset;
      width: 80%;
      justify-content: center;
      ul {
        flex-direction: row;
        // width: 40%;
        // justify-content: space-around;
        margin: 2em 0px;
      }
      li {
        width: 60px;
        height: 60px;
        margin-bottom: unset;
        margin-right: 10px;
        margin-left: 10px;
      }
    }
    .technology-cont {
      width: 100%;
      justify-content: center;
    }
    .vehicles-imgs {
      width: 100%;
      height: 310px;
      z-index: -1;
      .vehicle {
        height: 100%;
        width: 100%;
      }
      .vehicle-1-img {
        content: url("../assets/Tablet/Vehicle-1.png");
      }
      .vehicle-2-img {
        content: url("../assets/Tablet/Vehicle-2.png");
      }
      .vehicle-3-img {
        content: url("../assets/Tablet/Vehicle-3.png");
      }
    }
  }
}
@media (max-width: 600px) {
  body.technology {
    background-image: url("../assets/Mobile/Technology-Background.png");
  }
  .technology {
    .techonlogy-section {
      text-align: center;
      display: flex;
      flex-direction: column;
    }
    .titel {
      position: relative;
      left: unset;
      top: -4.5rem;
      z-index: 1;
    }
    .content {
      flex-direction: column-reverse;
      align-items: center;
      position: relative;
      top: 5em;
    }
    .sid-nav ul {
      margin: 1em 0px;
      li {
        width: 40px;
        height: 40px;
        margin-bottom: unset;
        margin-right: 5px;
        margin-left: 5px;
        font-size: 16px;
      }
    }
    label.titel-dic {
      font-family: Barlow Condensed;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 2.3625px;
    }
    p {
      width: 85%;
      margin-right: auto;
      margin-left: auto;
    }
  }
}
</style>
